import Enum from "../../../../../../enums/Enum";

const DurationEnum = new Enum({
    ACUTE: {name: "Acute", minDurationInDays: 1, maxDurationInDays: 42},
    SUBACUTE: {name: "Subacute", minDurationInDays: 42, maxDurationInDays: 84},
    CHRONIC: {name: "Chronic", minDurationInDays: 84, maxDurationInDays: Infinity}
});

export default DurationEnum;